<template>
    <div>
        <vue-spinner v-if="loading"></vue-spinner>
        <div class="general-item-list" v-if="notes.length">
            <div class="item" v-for="note in notes">
                <div class="item-head">
                    <a href="" @click.prevent="editNoteAction(note)">{{ note[note.type] }}</a>
                </div>
                <div class="item-body casenote-title" v-html="note.note"></div>
                <ul class="casenotes">
                    <li>
                        <div class="col1">
                            <div class="cont">
                                <div class="cont-col2">
                                    <div class="date">{{ note.createdAt.date | formatDate }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col2">
                            <div class="name"> {{ note.createdBy.fullName }}</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div v-else>
            <p>No records available.</p>
        </div>
        <div class="clearfix"></div>
    </div>
</template>
<script>
    import Spinner from '@/components/Spinner';
    import {HTTP} from "../../http-common";

    export default {
        props: ['participantId', 'assignmentId'],
        data() {
            return {
                notes: [],
                loading: false
            }
        },
        components: {
            'vue-spinner': Spinner,
        },
        mounted() {
            this.getHistoryNotes();
        },
        methods: {
            getHistoryNotes() {
                this.loading = true;
                HTTP.post('notes/assignment/index', {
                    'participant_id': this.participantId,
                    'assignment_id': this.assignmentId
                }).then(response => {
                    this.notes = response.data.data.index;
                }).catch(err => {
                    console.log(err);
                }).then(() => {
                    this.loading = false
                })
            }
        },
    }
</script>



// WEBPACK FOOTER //
// CommunicationNotes.vue?29ae5a24